// Keep internal deep links (including a selected connection interaction) across
// login without treating URL state as an external navigation destination.
const unsafe=value=>[...value].some(char=>char.charCodeAt(0)<=32||char==='\\')
export function loginReturnTo(from){
  const pathname=from?.pathname,search=from?.search??'',hash=from?.hash??''
  if(typeof pathname!=='string'||!pathname.startsWith('/')||pathname.startsWith('//')||(unsafe(pathname)||/[%?#]/.test(pathname)))return '/'
  if(typeof search!=='string'||search&&(!search.startsWith('?')||(unsafe(search)||search.includes('#'))))return '/'
  if(typeof hash!=='string'||hash&&(!hash.startsWith('#')||unsafe(hash)))return '/'
  return pathname+search+hash
}
